import { initializePixel, trackEvent } from './tracking';

const PIXEL_ID = import.meta.env.VITE_FB_PIXEL_ID;

export const initFacebookPixel = () => {
  if (!PIXEL_ID) {
    console.warn('Facebook Pixel ID is not configured');
    return;
  }

  initializePixel(PIXEL_ID);
};

export const trackPixelEvent = (eventName: string, data?: object) => {
  if (!PIXEL_ID) return;
  trackEvent(eventName, data);
};